
import { useState } from "react";
import Menu from '../menu/Menu';
import ChildSafetyPrivate from "./childsafetyPrivate";



export default function ChildSafetyScreenPrivate() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <ChildSafetyPrivate onOpenMenu={() => setIsMenuOpen(true)} />

      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-white">
          <Menu isLoggedIn={true} onClose={() => setIsMenuOpen(false)} />
        </div>
      )}
    </>
  );
}